import type { CopyId } from '@npc/copy'

/**
 * 「关注」这一页一条都没有时该说哪句话。
 *
 * 两种情况**下一个动作不一样**，就不许合成一句（CLAUDE.md §3）：
 *
 *   真的什么都没关注   → 他得先去关注点什么，给他一个去项目列表的入口
 *   关注了但最近没动静 → 他什么都不用做，说清楚就行
 *
 * 判据用后端算出来的 `following_count`（ActivityList.following_count），
 * 不是前端猜的。以前这里只有第一句，于是一个关注了三个项目的人
 * 打开这一页会看到「还没有关注任何东西」——一句他一眼就知道是假的话。
 *
 * 抽成纯函数是为了**两侧都取得到样**：走界面只到得了 followCount === 0
 * 那一侧（夹具里凡是空列表的 frame，following_count 都是 0），
 * 而一个只在一侧取过样的用例守不住这个 if。
 */
export function followingEmptyCopy(followCount: number): {
  titleId: CopyId
  descId: CopyId
  /** 「去项目列表」那个按钮只在「还没关注过」时给——已经关注了的人点它没意义。 */
  offerProjects: boolean
} {
  if (followCount > 0) {
    return {
      titleId: 'activity.empty.following.quiet.title',
      descId: 'activity.empty.following.quiet.hint',
      offerProjects: false,
    }
  }
  return {
    titleId: 'activity.empty.following.title',
    descId: 'activity.empty.following.hint',
    offerProjects: true,
  }
}

/**
 * 动态列表主区该画哪一种。
 *
 * GET 回来是 []、SSE 又断着的时候，**不许走 EmptyMatrix**。
 * 「现在什么都没发生」是一句结论，而这时我们根本接不上时间线，
 * 分不清「真的没有」和「流还没接上」。结论说错了，比空白糟。
 *
 * 读失败（listFailed）保持原话：那是另一件事，有自己的文案和重试。
 */
export function activityListBody(opts: {
  listFailed?: boolean
  disconnected: boolean
  itemCount: number
}): 'list_failed' | 'waiting' | 'empty' | 'items' {
  if (opts.listFailed) return 'list_failed'
  if (opts.disconnected && opts.itemCount === 0) return 'waiting'
  if (opts.itemCount === 0) return 'empty'
  return 'items'
}

